module.exports = __webpack_public_path__ + "img/justboil-logo.7298fabb.svg";